<template>
  <v-app>
    <template v-if="!bootstrapped">
      <div style="width: 100%; height: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
        <v-progress-circular indeterminate color="primary"/>
      </div>
    </template>
    <template v-if="bootstrapped">
      <Drawer v-if="isUserLoggedIn" />
      <Alerter />
      <v-app-bar
        v-if="isUserLoggedIn"
        app
        id="keep"
        clipped-left
        dark
        color="primary">
        <v-toolbar-title>{{this.iamTittle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" id="user_dropdown_menu">
              <v-icon class="pa-1">mdi-account</v-icon>
              {{firstname}} {{lastname}}
            </v-btn>
          </template>
          <v-list>
              <v-list-item v-if="showUserName"> {{username}} </v-list-item>
              <v-list-item @click="logout" id="logout-button">Logout</v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-main>
        <router-view />
      </v-main>
    </template>
  </v-app>
</template>

<script>
import Drawer from "./components/Drawer.vue"
import Alerter from "./components/Alerter.vue"
import axios from 'axios'
export default {
  name: "IAM",
  components: {
    Drawer,
    Alerter,
  },
  data() {
    return {
      colorBootstrapped: false,
      sessionBootstrapped: false
    }
  },
  created: function () {
    if (localStorage.getItem("brand")) {
      this.$vuetify.theme.themes.light = localStorage.getItem("brand")
    }
    axios.get('/api/1/admin/branding/color-scheme')
      .then((response) => {
        if(typeof response.data === 'object' && response.data !== null && Object.prototype.hasOwnProperty.call(response.data, 'primary')){
          if(response.data.primary !== null){
            this.$vuetify.theme.themes.light = response.data
            localStorage.setItem('brand', response.data)
          }
        }
        const style = document.createElement('style')
        style.textContent = `
div.body {
  background: black !important;
}
.main-container  {
  background: linear-gradient(90deg, ${response.data.primary} 0%, ${response.data.primary} 25%, ${response.data.primary}20 100%) !important;
}`
        document.head.append(style)
      }).finally(() => {this.colorBootstrapped = true})
    this.initSession(() => {
      this.sessionBootstrapped = true
    })
  },
  computed: {
    iamTittle: function () {return `${window.location.host}  -- Identity & Access manager`},
    isUserLoggedIn: function () { return(
      this.$route.name !== 'Login' &&
      this.$route.name !== 'LoginVerification' &&
      this.$route.name !== 'Register' &&
      this.$route.name !== 'ForgotPassword' && 
      this.$route.name !== 'NewPassword' &&
      this.$route.name !== 'Authorize')},
    showUserName: function () {return (this.$route.name !== 'Emails' && this.$route.name !== 'PhoneNumbers')},
    bootstrapped: function() {
      return this.sessionBootstrapped && this.colorBootstrapped
    }
  },
  methods: {
    logout(){
      window.location.href = '/logout'
    }
  }
}
</script>
<style style lang="scss">
* {
    box-sizing: border-box;
  }

.key{
  font-weight: bold;
}
.value{
  color: grey;
}
.v-data-table th {
    font-weight: 500 !important;
    font-size: 14px !important;
    color: rgba(0,0,0,.6) !important;
  }

  .v-data-table th {
    vertical-align: top !important;
    padding-top: 7px !important;
  }

  .v-data-table thead th {
    vertical-align: middle !important;
    padding-top: 0px !important;
  }

  .v-data-table th .v-icon {
    margin-top: -3px !important;
    margin-right: 7px !important;
    font-size: 18px !important;
  }
  .v-form {
    width: 100% !important;
    max-width: 450px !important;
    margin-left: 20px ;
  }
  .v-breadcrumbs {
    margin-left: -16px !important;
  }
</style>